const physicsCircles = [
  {
    id: 'ghaziabad-beamline-circle',
    name: 'Ghaziabad Beamline Circle',
    location: 'Ghaziabad, India',
    leader: {
      name: 'Yash Varshney',
      email: 'yash.gurukul12@gmail.com',
      photo: '/images/people/yash.png',
    },
    students: [
      'Samarth Arora',
      'Madhav Singh',
      'Achintya Tyagi',
      'Tarang Katiyar',
      'Siddharth Kumar',
      'Vansh Gupta',
      'Moulik Asthana',
      'Divyansh Sharma',
      'Vedang Gupta',
      'Mudit Kumar Tyagi',
      'Shivansh Yadav',
      'Suyash Agarwal',
    ],
  },
  {
    id: 'ghaziabad-simulation-circle',
    name: 'Ghaziabad Simulation Circle',
    location: 'Ghaziabad, India',
    leader: {
      name: 'Tranav Tyagi',
      email: 'tranav50@gmail.com',
      photo: '/images/people/Tranav.png',
    },
    students: [
      'Daksh Tanwar Rajput',
      'Prankur Agarwal',
      'Shivansh Jaitley',
      'Abu Akbar',
      'Divyam Gupta',
      'Vedansh Saxena',
      'Ekagrah Singh',
      'Shaurya Bhushan',
      'Daivik Garg',
      'Yash Aggarwal',
    ],
  },
  {
    id: 'hyderabad-collider-circle',
    name: 'Hyderabad Collider Circle',
    location: 'Hyderabad, India',
    leader: {
      name: 'Amolika Kaushal',
      email: 'amolika13620@gmail.com',
      photo: '/images/people/amolika.png',
    },
    students: [
      'Latika Penubolu',
      'Tanishka Upadhyay',
      'Anushree Panda',
      'Adith Reddy',
      'Adithi Reddy',
      'Aditi Singh',
      'Avni Kanchalwar',
      'Shravani Kanchalwar',
      'Nafisa Merchant',
    ],
  },
  {
    id: 'toronto-outreach-circle',
    name: 'Toronto Outreach Circle',
    location: 'Toronto, Canada',
    leader: {
      name: 'Toshani Sharma',
      email: 'toshani.sharma10@gmail.com',
      photo: '/images/people/Toshani.jpeg',
    },
    students: [
      'Janya Sharma',
      'Saksham Saraswat',
      'Evie Choi',
      'Ethan Nguyen',
      'Gold Akinloye',
      'Amber Tran',
      'Lucy Broughton',
      'Stevie Wesson',
    ],
  },
  {
    id: 'patna-prithvi-circle',
    name: 'Patna Physics Circle',
    location: 'Patna, India',
    leader: {
      name: 'Prithvi Sinha',
      email: '',
      photo: '/images/people/prithvi.jpeg',
    },
    students: [
      'Ajinkya Gahlaut',
      'Asmit Verma',
      'Warad',
      'Sashreek Shekhar',
      'Izma Khatri',
      'Abhinav Sinha',
      'Bhav Dadhich',
      'Naitik Singhania',
    ],
  },
  {
    id: 'cairo-physics-circle',
    name: 'Cairo Physics Circle',
    location: 'Cairo, Egypt',
    leader: {
      name: 'Marwan Elmoghazy',
      email: '',
      photo: '/images/people/Marwan.jpeg',
    },
    students: [
      'Youssef Nour',
      'Saleem Abdelkader',
      'Hamza Hussin',
      'Ahmed Sheriff',
      'Marwan Ayman',
      'Marwan Tarek',
      'Mohamed Amr',
      'Yamen Raaef',
    ],
  },
  {
    id: 'mumbai-exploration-circle',
    name: 'Mumbai Exploration Circle',
    location: 'Mumbai, India',
    leader: {
      name: 'Abhinav Jha',
      email: '',
      photo: '/images/people/Abhinav.jpeg',
    },
    students: [
      'Aditya Chaudhary',
      'Yash Sawant',
      'Hariom Jha',
      'Vedant Sangli',
      'Ansh Vishwakarma',
      'Vivek Sharma',
      'Bunty Sahu',
      'Piyush Galvano',
      'Umesh Prajapati',
      'Priya Shirke',
    ],
  },
  {
    id: 'mumbai-physics-circle',
    name: 'Mumbai Physics Circle',
    location: 'Mumbai, India',
    leader: {
      name: 'Grisha Raval',
      email: '',
      photo: '/images/people/Grisha Raval.jpeg',
    },
    students: [
      'Moksha Mehta',
      'Mahi Shah',
      'Vaishnavi Jagad',
      'Vreeti Doshi',
      'Bhavya Shah',
      'Swayam Zatakia',
      'Hetansh Patel',
      'Neev Desai',
      'Rhea Vahalia',
      'Divyam Doshi',
    ],
  },
  {
    id: 'sandton-physics-circle',
    name: 'Sandton Physics Circle',
    location: 'Sandton, South Africa',
    leader: {
      name: 'Ishan Dogra',
      email: '',
      photo: '/images/people/Ishan.jpeg',
    },
    students: [
      'Jonathan Evans',
      'Day Marisa',
      'Kopano Mphago',
      'Andy Rajaobelina',
      'Tumi Sibeko',
      'Micheal Mizidvuri',
      'Jeremiah Mabuse',
      'Jason Grage',
      'Koma Mahalele',
    ],
  },
];

export default physicsCircles;
